import { Button } from '@mui/material';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import API from '../../api';
import { ModalReductionAction, PageHeader } from '../../components';
import { FormRadio } from '../../components/form/FormRadio';
import { SnackbarContext } from '../../contexts';
import { useLabel } from '../../hooks';
import { buttonStyle, modalStyle } from '../../styles/style';
import { ReductionForm } from './form/components/ReductionForm';
import { useReduction } from './hooks';

export const ReductionWritingPage = (props) => {
  const history = useHistory();
  const { t } = useTranslation();
  const { slug } = useParams();
  const { HOME_ICON } = useLabel();
  const { updateSnackbar } = useContext(SnackbarContext);

  const { control, handleSubmit, watch } = useForm({
    mode: 'onChange',
    defaultValues: {
      projectSeq: '',
    },
  });

  const { reduction, getReduction, getReductionProjectList, reductionProjectList, postReduction } = useReduction();

  useEffect(() => {
    if (slug) {
      getReduction();
    } else {
      getReductionProjectList();
    }
  }, [slug]);

  //보완 완료용 모달
  const [actionOpen, setActionOpen] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);
  const [selectedNextAction, setSelectedNextAction] = useState(null);
  const projectSeq = watch('projectSeq');

  const closeActionModal = () => {
    setActionOpen(false);
    setSelectedAction(null);
    setSelectedNextAction(null);
  };

  const handleModalRequest = useCallback(
    (body) => {
      API.ReductionCert.PostNextAction(slug, {
        nextAction:
          selectedNextAction === 'ImproveReductionCertComplete'
            ? 'ImproveReductionCertComplete'
            : 'ReductionCertSubmit',
      })
        .then((res) => {
          history.push('/request_complete?type=reduction');
        })
        .catch((err) => {
          updateSnackbar({
            type: 'error',
            open: true,
            message: err.data.message,
          });
        });
    },
    [slug, selectedNextAction, history, updateSnackbar],
  );

  const createReduction = useCallback(async () => {
    await postReduction(projectSeq);
  }, [projectSeq, postReduction]);

  const renderForm = useMemo(() => {
    if (slug) {
      return (
        <ReductionForm
          reduction={reduction}
          setActionOpen={setActionOpen}
          setSelectedAction={setSelectedAction}
          setSelectedNextAction={setSelectedNextAction}
        />
      );
    }

    return reductionProjectList.length > 0 ? (
      <div className='flex flex-col items-center justify-center gap-4 min-h-[30vh]'>
        <h2 className='font-semibold'>{HOME_ICON.REDUCTION}</h2>
        <p>{t('SELECT_PROJECT_FOR_REDUCTION_CERT')}</p>
        <div className='py-8 flex flex-col gap-4 border border-solid border-gray-200 rounded-lg p-4'>
          <FormRadio
            control={control}
            name='projectSeq'
            radioGroupSx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
            }}
            menus={reductionProjectList?.map((item) => ({
              label: item.title,
              value: item.seq,
            }))}
          />
          <Button
            variant='contained'
            color='primary'
            disableElevation
            sx={{
              ...buttonStyle,
              width: '100%',
              mt: 2,
            }}
            disabled={!projectSeq}
            onClick={() => {
              createReduction();
            }}
          >
            {HOME_ICON.REDUCTION}
          </Button>
        </div>
      </div>
    ) : null;
  }, [slug, reductionProjectList, projectSeq, createReduction]);

  return (
    <article className='basic-page'>
      <PageHeader title={HOME_ICON.REDUCTION} type='reduction' />
      <article className='block'>{renderForm}</article>

      <Modal open={actionOpen} onClose={closeActionModal}>
        <Box sx={modalStyle}>
          <ModalReductionAction
            action={selectedAction}
            nextAction={selectedNextAction}
            requestAction={handleModalRequest}
            onClose={closeActionModal}
          ></ModalReductionAction>
        </Box>
      </Modal>
    </article>
  );
};
